<template>
	<div class="main">
		<header class="page-title">
			<h2>Upcoming Events</h2>
		</header>
		<div class="card">
			<header class="card-header">
				<h3 class="card-title">Birthdays and Work Anniversaries</h3>
			</header>
			<div class="card-body">
				<div class="flex box" v-if="userRoles.includes('hr.create')">
					<div class="four-lg">
						<h4 class="card-subtitle">Today's Birthdays</h4>
						<div class="alert alert-success alert--small" v-for="event in events.currentBirthdays">
							<div class="alert-icon fas fa-birthday-cake"></div>
							<div class="alert-content">
								<h4>{{ event.full_name }}'s</h4>
								<p>birthday is today!</p>
							</div>
						</div>
					</div>
					<div class="four-lg">
						<h4 class="card-subtitle">Upcoming Birthdays</h4>
						<div class="alert alert-primary alert--small" v-for="event in events.upcomingBirthdays">
							<div class="alert-icon fas fa-birthday-cake"></div>
							<div class="alert-content">
								<h4>{{ event.full_name }}'s</h4>
								<p>birthday in {{ event.birthdayInDays }} {{ event.birthdayInDays > 1 ? 'days' : 'day' }}
									({{ event.birthday }})</p>
							</div>
						</div>
					</div>
					<div class="four-lg">
						<h4 class="card-subtitle">Work Anniversaries</h4>
						<div :class="event.workStartInDays === 0 ? 'alert alert--small alert-warning' : 'alert alert--small alert-primary'"
							 v-for="event in events.workAnniveries">
							<div class="alert-icon fas fa-glass-cheers"></div>
							<div class="alert-content">
								<h4>{{ event.full_name }}'s</h4>
								<p>work anniversary is {{ event.workStartInDays === 0 ? 'today' : ' in ' + event.workStartInDays + ' days' }}!</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="card">
			<header class="card-header">
				<h3 class="card-title">Day-Offs</h3>
			</header>
			<div class="card-body">
				<div class="flex box">
					<div class="four-lg">
						<h4 class="card-subtitle">Currently Away</h4>
						<div class="alert alert-danger alert--small" v-for="event in events.currentAway">
							<div class="alert-icon fas fa-globe-europe"></div>
							<div class="alert-content">
								<h4>{{ event.username }}</h4>
								<p>{{ event.endsInText }}</p>
								<p>{{ event.start_date }} - {{ event.end_date }}</p>
							</div>
						</div>
					</div>
					<div class="four-lg">
						<h4 class="card-subtitle">Upcoming Day-Offs</h4>
						<div class="alert alert-warning alert--small" v-for="event in events.upcomingAway">
							<div class="alert-icon fas fa-globe-europe"></div>
							<div class="alert-content">
								<h4>{{ event.username }}</h4>
								<p>{{ event.startsInText }}</p>
								<p>{{ event.start_date }} - {{ event.end_date }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currentUser: this.$currentUser,
			userRoles: this.$currentUserRoles,

			events: {},
		}
	},
	created() {
		this.fetchEventsData();
	},
	methods: {
		fetchEventsData: function () {
			let vm = this;
			axios.get('/api/hr/events'
			).then(function (response) {
				vm.events = response.data;
			});
		},
	}
}
</script>
